module.exports = __webpack_public_path__ + "static/img/0_4.c217788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/0_4.png
// module id = ak7g
// module chunks = 12